import { registerCustomElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { FlagEditTemplate } from "../Templates/DataTypeEditTemplates/FlagEditTemplate";
import { FlagTemplates } from "../Templates/DataTypeTemplates/FlagTemplates";
import { Column } from "./Column";

export class FlagColumn extends Column {
    //#region Fields
    //#endregion

    //#region Methods

    //#endregion Methods

    //#region HTMLElement
    protected override _constructor(): void {
        super._constructor();

        this.itemTemplate = new FlagTemplates();
        this.editItemTemplate = new FlagEditTemplate();
    }
    //#endregion HTMLElement
} //end Column

registerCustomElement("tsc-flagolumn", FlagColumn);
